module.exports = __webpack_public_path__ + "media/images/icon-benefits-mentalhealth-1dd63721d61b8cdc3eac021ad0286bfb.png";